import { render, staticRenderFns } from "./SingleVersionSelection.vue?vue&type=template&id=37392418&"
import script from "./SingleVersionSelection.vue?vue&type=script&lang=ts&"
export * from "./SingleVersionSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports